import type { AudioObject } from '@powerplay/core-minigames'
import {
  AudioCategories,
  AudioGroups,
  AudioNames
} from '../types'

export const audioSprites: AudioObject[] = [
  {
    files: [
      AudioNames.spriteFootsteps
    ],
    startOnRandomPlace: false,
    randomDelayBeforeStartFrom: 0,
    randomDelayBeforeStartTo: 0,
    enabled: true,
    volume: 1,
    volumeRandom: 0,
    rate: 1,
    rateRandom: 0,
    loop: false,
    // subset: true,
    // randomizeSprite: true,
    category: AudioCategories.sprite,
    version: 2,
    sprite: {
      'footstep-player1': [
        0,
        384.01360544217687
      ],
      'footstep-player10': [
        2000,
        359.9999999999999
      ],
      'footstep-player2': [
        4000,
        384.01360544217675
      ],
      'footstep-player3': [
        6000,
        360.00000000000034
      ],
      'footstep-player4': [
        8000,
        384.01360544217766
      ],
      'footstep-player5': [
        10000,
        335.98639455782296
      ],
      'footstep-player6': [
        12000,
        335.98639455782296
      ],
      'footstep-player7': [
        14000,
        335.98639455782296
      ],
      'footstep-player8': [
        16000,
        359.99999999999943
      ],
      'footstep-player9': [
        18000,
        384.01360544217766
      ]
    }
  },
  {
    files: [
      AudioNames.spriteCommentators
    ],
    startOnRandomPlace: false,
    randomDelayBeforeStartFrom: 0,
    randomDelayBeforeStartTo: 0,
    ignoreModes: [3, 14, 9, 10],
    volume: 1,
    volumeRandom: 0,
    rate: 1,
    rateRandom: 0,
    enabled: true,
    loop: false,
    category: AudioCategories.sprite,
    randomizeSprite: true,
    group: AudioGroups.commentators,
    subset: true,
    sprite: {
      'after_last_throw_rank_1_best_throw': [
        0,
        6614.263038548753
      ],
      'after_last_throw_rank_1_no_improvement': [
        8000,
        5699.7732426303855
      ],
      'after_last_throw_rank_23_best': [
        15000,
        4303.9682539682535
      ],
      'after_last_throw_rank_23_no_improvement': [
        21000,
        5839.115646258502
      ],
      'after_last_throw_rank_45': [
        28000,
        5714.96598639456
      ],
      'after_last_throw_rank_6': [
        35000,
        4990.498866213152
      ],
      'after_throw_foul_01': [
        41000,
        2353.3786848072536
      ],
      'after_throw_foul_012': [
        45000,
        3926.5079365079387
      ],
      'after_throw_no_improvement_bad_01': [
        50000,
        3004.4217687074806
      ],
      'after_throw_no_improvement_bad_012': [
        55000,
        3668.1405895691623
      ],
      'after_throw_no_improvement_good_01': [
        60000,
        5350.204081632654
      ],
      'after_throw_no_improvement_good_012': [
        67000,
        4063.3333333333326
      ],
      'after_throw_personal_best_01': [
        73000,
        5512.312925170065
      ],
      'after_throw_personal_best_012': [
        80000,
        5226.077097505666
      ],
      'after_throw_rank_1_01': [
        87000,
        5058.888888888888
      ],
      'after_throw_rank_1_012': [
        94000,
        4471.179138322001
      ],
      'after_throw_rank_23_01': [
        100000,
        3549.047619047613
      ],
      'after_throw_rank_23_012': [
        105000,
        4151.972789115646
      ],
      'after_throw_rank_45_01': [
        111000,
        2784.036281179141
      ],
      'after_throw_rank_45_012': [
        115000,
        3169.070294784575
      ],
      'after_throw_rank_6_01': [
        120000,
        3435.056689342403
      ],
      'after_throw_rank_6_012': [
        125000,
        5177.936507936522
      ],
      'after_throw_world_record': [
        132000,
        5294.444444444452
      ]
    }
  }
]